import PropTypes from "prop-types";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { Modal, ModalBody } from "reactstrap";
import { customPublish } from "@pages/publish/services/publish.services";

const PublishModel = ({ show, onCloseClick, data, field }) => {
  const dispatch = useDispatch();
  const [error, setError] = useState(null);
  const handlePublish = async (data) => {
    try {
      const formattedData = {
        type: data.type === "post" ? 1 : 2,
        post_id: field === "post" ? data.id : null,
        media_id: field === "media" ? data.id : null,
        is_publish: !data.published_at ? true : false,
      };
      await dispatch(
        customPublish({ id: data.id, data: formattedData })
      ).unwrap();
      onCloseClick();
    } catch (error) {
      setError(
        `Unable to ${
          !data.published_at ? "publish" : "unpublish"
        } record please check ${field} data is there`
      );
    }
  };
  return (
    <Modal size="md" isOpen={show} toggle={onCloseClick} centered={true}>
      <div className="modal-content">
        <ModalBody className="px-4 py-5 text-center">
          <button
            type="button"
            className="btn-close position-absolute end-0 top-0 m-3"
            onClick={() => {
              onCloseClick();
              setError(null);
            }}
          ></button>
          <div className="avatar-sm mb-4 mx-auto">
            <div className="avatar-title bg-primary text-primary bg-opacity-10 font-size-20 rounded-3">
              {!data.published_at ? (
                <i className="mdi mdi-check-circle-outline text-success"></i>
              ) : (
                <i className="mdi mdi-close-circle-outline text-danger"></i>
              )}
            </div>
          </div>
          <p className="text-muted font-size-16 mb-4">
            Are you sure you want to{" "}
            {!data.published_at ? "publish" : "unpublish"} the data
          </p>
          <p className="text-danger fs-6">{error}</p>
          <div className="hstack gap-2 justify-content-center mb-0">
            <button
              type="button"
              className={
                !data.published_at ? "btn btn-success" : "btn btn-secondary"
              }
              onClick={() => {
                handlePublish(data);
                setError(null);
              }}
            >
              {!data.published_at ? "Publish" : "Unpublish"}
            </button>
            <button
              type="button"
              className="btn btn-secondary"
              onClick={() => {
                onCloseClick();
                setError(null);
              }}
            >
              Close
            </button>
          </div>
        </ModalBody>
      </div>
    </Modal>
  );
};

PublishModel.propTypes = {
  onCloseClick: PropTypes.func,
  show: PropTypes.bool,
  data: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    post_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    media_id: PropTypes.oneOfType([PropTypes.number, PropTypes.number]),
    type: PropTypes.number,
    published_at: PropTypes.string,
  }).isRequired,
  onPublishClick: PropTypes.func,
  field: PropTypes.string,
};
export default PublishModel;
